<template>
    <div>
        <b-modal
            size="md"
            v-model="modalShow"
            :title="`専属${$locale.patient}利用停止`"
            ok-title="利用停止"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            @ok="stopUser"
            @cancel="close"
            @hidden="close">
            <div v-if="user">
                <div class="modal-body">
                    <div class="jumbotron pt-3 pb-3">
                        <p>{{ $locale.patient }}番号：{{ user.id }}</p>
                        <p>名前：{{ user.full_name }} （ {{ user.full_name_kana }} ）</p>
                        <p>年齢：{{ user.age }}</p>
                    </div>
                    <p class="text-center">上記の{{ $locale.patient }}を利用停止します。<br>よろしいですか？</p>
                </div>
            </div>
            <div
                slot="modal-footer"
                class="w-100"
                :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button class="btn btn-yokumiru-orange float-right" @click="stopUser">利用停止</button>
                <button class="btn btn-yokumiru-gray float-right mr-2" @click="close">キャンセル</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        name: 'ExclusiveUserStopModal',

        data: function () {
            return {
                inProgress :false,
                modalShow: false,
                user: null,
                doctorId: null,
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-exclusive-user-stop', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-exclusive-user-stop')
        },

        methods: {
            /**
             * モーダルを表示
             *
             * @param {object} user
             * @param {number} doctorId
             */
            open: function (user , doctorId) {
                this.modalShow = true
                this.user = user
                this.doctorId = doctorId
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false
                this.errors = {}
            },

            /**
             * 利用停止
             */
            stopUser: async function() {
                if (this.inProgress) return
                this.inProgress = true

                await axios.post(`/doctor/api/${this.doctorId}/users/exclusive/stop/${this.user.id}`)
                    .then(() => {
                        bus.$emit('alert-success', '利用停止しました。')
                        bus.$emit('refresh-exclusive-users')
                        this.close()
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    }
</script>
